export class Alert {
    public alertId!: string;
    public keepAfterRouteChange!: boolean;
    public message!: string;
    public type!: AlertType;



    constructor(init?: Partial<Alert>) {
        Object.assign(this, init);
    }
}

export enum AlertType {
    Success,
    Error,
    Info,
    Warning
}
